<template>
  <transition name="panel" v-on="$listeners">
    <div v-if="isOpen" class="panel-content">
      <slot :set-panel="setPanel" />
    </div>
  </transition>
</template>

<script lang="ts">
import { Vue, Prop, Component, Inject } from 'vue-property-decorator';
@Component({})
export default class NavigationPanel extends Vue {
  @Prop({ type: Boolean, default: false })
  public isOpen!: boolean;

  @Inject({
    from: 'setPanel',
    default: () => {}
  })
  private readonly setPanel!: () => {};
}
</script>

<style lang="less" scoped>
@time: 400ms;
@ease: cubic-bezier(0.55, 0, 0.1, 1);

.panel-content {
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  transition: transform @time @ease;
}
.panel-enter,
.panel-leave-to {
  transform: translate(100%, 0);
}
</style>
